import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/PrivacyPolicy.css';

function Privacypolicy() {
    const [loading, setLoading] = useState(true);
    const [policy, setPolicy] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    
    // Base URL for API calls
    const baseUrl = process.env.REACT_APP_NODE_ENV === 'production' 
        ? process.env.REACT_APP_PRODUCTION_BASE_URL 
        : process.env.REACT_APP_DEVELOPMENT_BASE_URL;

    useEffect(() => {
        // Load Font Awesome for icons
        const loadFontAwesome = () => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
            document.head.appendChild(link);
            return () => document.head.removeChild(link);
        };

        const cleanupFontAwesome = loadFontAwesome();

        const fetchPolicy = async () => {
            try {
                const response = await axios.get(`${baseUrl}/api/settings-text`);
                if (response.data.success) {
                    // Extract just the policy text from the settings response
                    const policyData = {
                        policyText: response.data.data.policyText
                    };
                    setPolicy(policyData);
                }
            } catch (error) {
                console.error('Error fetching privacy policy:', error);
                setError('Failed to load privacy policy');
            } finally {
                setLoading(false);
            }
        };

        fetchPolicy();
        
        // Scroll to top on component mount
        window.scrollTo(0, 0);

        return cleanupFontAwesome;
    }, [baseUrl]);

    const handleBackClick = () => {
        navigate('/');
    };

    return (
        <div className="privacy-policy-page">
            <div className="container py-5">
                <div className="back-button" onClick={handleBackClick}>
                    <i className="fas fa-arrow-left"></i> Back to Home
                </div>
                <div className="privacy-policy-content">
                    {loading ? (
                        <div className="loading text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Loading privacy policy...</p>
                        </div>
                    ) : error ? (
                        <div className="error">
                            <h2>Error</h2>
                            <p>{error}</p>
                        </div>
                    ) : policy && policy.policyText ? (
                        <div className="policy-content">
                            <h1>Privacy Policy</h1>
                            <div dangerouslySetInnerHTML={{ __html: policy.policyText }} />
                        </div>
                    ) : (
                        <div className="notice">
                            <h2>Notice</h2>
                            <p>Privacy policy is currently being updated. Please check back later.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Privacypolicy;